// Message templates: the list per channel, Sync from Exotel, "not for campaigns", and the mock API's "Simulate: Meta
// approved" (Test tools). Templates are made in Meta's WhatsApp Manager, not here (owner 2026-11-02).
import { useQuery } from '@tanstack/react-query'
import { useApi } from '@/api/ApiProvider'
import type { TemplateChannel } from '@/api/schemas'
import { useChange } from '@/api/useChange'

const keys = { list: (channel: TemplateChannel) => ['templates', channel] as const }

export function useTemplates(channel: TemplateChannel) {
  const api = useApi()
  return useQuery({ queryKey: keys.list(channel), queryFn: () => api.listTemplates({ channel }) })
}

export const useSyncTemplates = () => useChange((api) => api.syncTemplates())

export const useSetTemplateForCampaigns = () =>
  useChange((api, args: { id: string; forCampaigns: boolean }) =>
    api.setTemplateForCampaigns(args.id, args.forCampaigns)
  )

export const useSimulateTemplateDecision = () =>
  useChange((api, args: { id: string; decision: 'approved' | 'rejected' }) =>
    api.demo!.simulateTemplateDecision(args.id, args.decision)
  )
